import React from "react";

import greenIndicator from "../../assets/imgs/update.png";

import styles from "../ChangeServiceLineWarning/ChangeServiceLineWarning.module.scss";

export const ChangeContigoResponsibleWarning = () => (
  <section
    className={styles.container}
    style={{
      gap: 0,
    }}
  >
    <img
      src={greenIndicator}
      alt="Ok image"
      style={{
        padingBttom: 0,
        width: "42px"
      }}
    />
    <h2 className={styles.title}>Estás a punto de cambiar el responsable del monitoreo</h2>
    <span
      className={styles.subtitle}
      style={{
        fontSize: "14px",
        lineHeight: "17px"
      }}
    >
      ¿Deseas continuar?
    </span>
  </section>
);